export default {
  errors: {
    base_errors: {
      create_title: 'Error al crear',
      update_title: 'Error al actualizar'
    },
    client: {
      base: {
        client_already_exists_add_sequential_id_to_update:
          'El cliente ya existe, agregue el ID secuencial (#) en una columna para relacionarlo con el cliente',
        client_not_found_by_sequential_id: 'No se encontró el cliente por el ID secuencial',
        multiple_clients_with_same_name_add_sequential_id:
          'Existen múltiples clientes con el mismo nombre, agregue el ID secuencial (#) en una columna para relacionarlo con el cliente'
      },
      city_invalid_for_dian: 'Ciudad no coincide con datos de DIAN',
      client_taxpayer_identification_number_invalid: 'Cédula/RUC del cliente no es valida',
      client_phone_mobile_invalid: 'El Teléfono móvil no es valido.',
      invalid_phone_mobile: 'Número de teléfono invalido',
      invalid_phone_number: 'Número de teléfono invalido',
      state_invalid_for_dian: 'Estado no coincide con datos de DIAN',
      taxpayer_identification_number: {
        greater_than:
          'Debe ingresar los números sin espacios ni guiones. Debe contenter {{count}} caracteres máximos. No puede empezar con 0.',
        maxLength:
          'Debe ingresar los números sin espacios ni guiones. Debe contenter {{count}} caracteres máximos. No puede empezar con 0.',
        pattern:
          'Debe ingresar los números sin espacios ni guiones. Debe contenter {{count}} caracteres máximos. No puede empezar con 0.'
      }
    },
    client_reference: {
      not_found: 'No se encontró el cliente con la referencia {{reference}}'
    },
    messages: {
      already_exist: 'Ya existe',
      already_used_seal: 'El precinto ya esta en uso',
      api_key: {
        empty: 'Debe ingresar un Api Key',
        invalid: 'Api key invalida'
      },
      at_least_one_port: 'Se necesita al menos un puerto: SSH o Telnet',
      authorize_invoice_after_paid_must_be_disabled_if_has_dgo_subscription:
        'Debe estar desactivado si el cliente posee una suscripción de Directv Go',
      between: 'debe estar entre {{first}} y {{last}}',
      blank: 'no puede estar en blanco',
      body_length_without_variables: 'La longitud del cuerpo no es válida',
      can_use_gateway_if_network: 'Si el contrato es de Red, no puede usarse gateway.',
      cannot_be_canceled_used_in_draft_invoice: 'No puede ser cancelado. Se está aplicando en facturas borradores.',
      cannot_be_destroyed: 'No puede ser eliminado.',
      cannot_be_destroyed_used_in_contracts: 'No puede ser eliminado. Se está aplicando a uno o más contratos.',
      cannot_be_destroyed_used_in_draft_invoice: 'No puede ser eliminado. Se está aplicando en facturas borradores.',
      cannot_be_equal: 'No puede ser igual a {{value}}.',
      cannot_be_modified_used_in_contracts: 'No puede ser modificado. Se está aplicando a uno o más contratos.',
      cannot_destroy_olt_with_contracts: 'No se puede eliminar la OLT porque tiene contratos asociados.',
      cannot_disable_radius_if_has_associated_nases:
        'No puede deshabilitar el servicio de radius si tiene NAS vinculado',
      cannot_have_navigation_vlan: 'La VLAN ya contiene este valor',
      cant_assign_coverage_with_olt_enabled: 'No se puede asignar cobertura con OLT habilitada',
      cant_be_a_past_date: 'No puede ser una fecha pasada',
      cant_be_equal_to_time_from: 'No puede ser igual a la hora de inicio',
      cant_be_equal_to_time_to: 'No puede ser igual a la hora de finalización',
      cant_be_positive: 'El valor no puede ser positivo.',
      cant_be_zero: 'El valor no puede ser cero.',
      cant_change_olt_with_contracts: 'No se puede cambiar OLT con contratos',
      cant_change_server_if_exist_full_nat: 'No se puede cambiar de servidor si se tiene asociado a FULL-NAT',
      cant_make_argentina_a_or_b_if_contract_recurring_item_tax_zero:
        'No se puede elegir Argentina A o B si el impuesto del contrato es cero.',
      cant_remove_with_help_desk_issue_comments:
        'No se puede eliminar porque tiene comentarios en tickets de Mesa de Ayuda',
      cant_use_as_full_nat_if_has_forwarded_ports:
        'No se puede utilizar para FULL-NAT ya que se esta usando para redirección de puertos',
      cant_use_degraded_in_old_bmu:
        'El estado Degradado está solo disponible para Mikrotik o BMU versión 0.7.3 en adelante',
      cant_use_dhcp_without_mac: 'No se puede habilitar el DHCP si no tiene alguna de las mac address',
      cant_use_dns_one_if_network: 'Si el contrato es de Red, no puede usarse el primer dns.',
      cant_use_dns_two_if_network: 'Si el contrato es de Red, no puede usarse el segundo dns.',
      cant_use_rimpe_and_pyme: 'No se puede tener activado Microempresa y RIMPE al mismo tiempo',
      cant_use_taxes_if_vat_condition_is_exempt: 'Si la condición de IVA es exento, no puedo utilizar ningun impuesto',
      cant_use_this_service: 'Solo puede usar uno de los siguientes servicios: {{services}}',
      cant_use_this_service_if_is_single_host: 'Solo se puede usar este servicio si es un host /32',
      capacity_cant_be_less_than_contracts: 'La capacidad no puede ser menor a la cantidad de contratos',
      categories_ids_not_found: 'Las categorías no existen',
      category_not_found: 'Las categoría no existe',
      client_item_tax_igv: 'Solo se puede tener un impuesto de tipo IGV del 18%',
      recurring_item_tax_igv: 'Solo se puede tener un impuesto de tipo IGV del 18%',
      client_item_tax_peru_presence: 'Debe tener un impuesto de tipo IGV',
      client_item_tax_peru_uniqueness: 'Debe tener un solo impuesto de tipo IGV',
      client_not_found: 'No se encontró el cliente',
      colombia: {
        common_regime_juridical: 'Ingresar un formato válido',
        //FIXME mejora poner un ejemplo en la ayuda AuxHints
        common_regime_person: 'Ingresar un formato válido'
      },
      colombia_invalid_credentials: 'Credenciales invalidas',
      colombia_siigo_need_use_net_amount:
        'Para facturar con Siigo, debe usar los montos de facturación como valores netos',
      connection_only_can_be_by_ssh: 'Se requiere el puerto SSH',
      connection_only_can_be_by_telnet: 'Se requiere el puerto Telnet',
      contract_discounts_cannnot_be_greater_than_discount_limit:
        'La suma de los descuentos no puede superar el límite de 90%',
      contract_discounts_must_be_unique: 'No puede agregar el mismo descuento múltiples veces en curso.',
      contract_identifier_missing: 'Debe seleccionar al menos un identificador del contrato',
      contract_not_found: 'Contrato no encontrado',
      contracts: 'contratos',
      contracts_limit_reached:
        'La cantidad máxima de contratos en la suscripción ha sido alcanzada, por favor actualice su suscripción.',
      country_category_must_have_scope: 'Debes seleccionar al menos un país',
      dns_one_cant_be_blank: 'El primer DNS no puede estar en blanco',
      dns_one_cant_be_equal_to_dns_three: 'No puede ser igual al Tercer servidor DNS',
      dns_one_cant_be_equal_to_dns_two: 'No puede ser igual al Segundo servidor DNS',
      dns_three_cant_be_equal_to_dns_one: 'No puede ser igual al Primer servidor DNS',
      dns_three_cant_be_equal_to_dns_two: 'No puede ser igual al Segundo servidor DNS',
      dns_two_cant_be_equal_to_dns_one: 'No puede ser igual al Primer servidor DNS',
      dns_two_cant_be_equal_to_dns_three: 'No puede ser igual al Tercer servidor DNS',
      duplicated_entry: 'No puedes agregar valores repetidos',
      duplicated_ip: 'IP Duplicada',
      ecuador: {
        taxpayer_identification_number:
          'Debe ingresar los números sin espacios ni guiones. Debe contenter {{count}} caracteres máximos.'
      },
      empty: 'no puede estar vacío',
      empty_translation: 'Traducción vacía',
      error_fetching_data: 'Error al buscar los datos',
      error_find_siigo_payment_way: 'Error al consultar las formas de pago de Siigo',
      error_find_siigo_validation_setting: 'Error al consultar la configuración de Siigo',
      exact_number_lenght: 'no tiene la longitud correcta ({{count}} caracteres exactos)',
      'execution expired': 'Timeout: no se recibe respuesta',
      exist_another_contract_cable_modem_ip_with_the_same_ip: 'Existe otro contrato con la misma IP de Cable Modem.',
      exist_another_contract_with_the_same_ip: 'Existe otro contrato con la misma IP',
      failed_to_load_qr_try_again: 'No se pudo obtener el QR, vuelva a intentar',
      free_ports_must_be_greater_than_or_equal_to_not_assigned_contracts:
        'La cantidad de puertos libres debe ser mayor o igual que la cantidad de contratos sin puerto asociados a la NAP',
      from_day_cant_less_or_equal_than_from_day: 'La fecha Hasta no puede ser menor o igual a la fecha Desde',
      gateway_cant_be_blank: 'El gateway no puede estar en blanco',
      greater_than: 'debe ser mayor que {{count}}',
      greater_than_or_equal_to: 'debe ser mayor que o igual a {{count}}',
      greater_than_rx_power_critical_lower: 'El valor no puede ser menor que el Critical lower threshold.',
      greater_than_rx_power_warning_lower: 'El valor no puede ser menor que el Warning lower threshold.',
      greater_than_rx_power_warning_upper: 'El valor no puede ser menor que el Warning Upper threshold.',
      identifier_missing: 'debe seleccionar al menos un identificador',
      inclusion: '{{value}} no es válido',
      interface_not_belongs_to_server: 'La interfaz no pertenece al servidor del contrato',
      invalid: 'no es válido',
      invalid_button_keys: 'Claves de botón inválidas',
      invalid_credentials: 'Credenciales inválidas',
      invalid_date: 'Fecha inválida',
      invalid_fbp: 'Formato FBP inválido',
      invalid_for_dian: 'Requerido si razón social es electrónica',
      invalid_format_mx: 'No corresponde al formato de RFC',
      invalid_integration_keys: 'Claves de integración inválidas',
      invalid_phone_mobile: 'Número de teléfono invalido',
      invalid_phone_number: 'Número de teléfono invalido',
      invalid_pos_token: 'Punto de venta inválido',
      invalid_private_key: 'Llave privada inválida',
      invalid_refresh_page: 'Error inesperado al crear el pago. Por favor intenta nuevamente.',
      invalid_select_option: 'Opción inválida',
      invalid_suffix: 'Número inválido',
      invalid_url: 'URL invalida',
      // EmailVerifier verification_feedback codes (mirror activerecord.errors.messages on the backend).
      // {{value}} is the address being validated; the backend passes it via errors.add(..., value: address).
      invalid_address_syntax: '{{value}} no tiene un formato de email válido',
      address_too_long: '{{value}} supera el largo máximo permitido (254 caracteres)',
      local_part_too_long: 'el nombre de usuario en {{value}} supera los 64 caracteres permitidos',
      domain_too_long: 'el dominio en {{value}} supera los 255 caracteres permitidos',
      domain_label_too_long: '{{value}} contiene una sección de dominio mayor a 63 caracteres',
      dns_timeout: 'no se pudo verificar el dominio de {{value}}; el servidor DNS no respondió a tiempo',
      domain_not_found: 'el dominio de {{value}} no existe',
      domain_does_not_accept_mail: 'el dominio de {{value}} está configurado para no recibir correos',
      mx_targets_unresolvable: 'los servidores de correo de {{value}} no respondieron, puede reintentarse más tarde',
      no_mail_destination: 'el dominio de {{value}} no tiene un servidor configurado para recibir correos',
      invoice_already_paid: 'La factura ya ha sido pagada',
      invoice_not_found: 'No se encontró la factura',
      invoice_void: 'La factura ha sido anulada',
      isNumber: 'No es un número',
      isp_category_must_have_scope: 'Debes seleccionar al menos un ISP',
      kind_taken: '{{kind}} ya está en uso',
      less_than: 'debe ser menor que {{count}}',
      less_than_or_equal_to: 'debe ser menor que o igual a {{count}}',
      maxLength: 'es demasiado largo ({{count}} caracteres máximo)',
      //react-hook-form
      mexico: {
        mexico_juridic: 'Ingresar formato RFC válido.',
        mexico_natural: 'Ingresar formato RFC válido.'
      },
      minLength: 'es demasiado corto ({{count}} caracteres mínimo)',
      missing_required_headers: 'Faltan seleccionar encabezales obligatorios',
      multiple_clients_by_reference: 'Se encontraron múltiples clientes',
      multiple_invoices_found: 'Se encontraron múltiples facturas',
      multiple_records_found: 'se encontró mas de un registro',
      must_be_a_valid_number: 'Debe ser un número valido',
      must_be_enabled_if_has_dgo_subscription: 'Debe estar activado si el cliente posee una suscripción de Directv Go',
      must_enter_exactly_numbers: 'Debes ingresar exactamente {{number}} números',
      must_have_invoice_provider: 'Debes seleccionar un Proveedor',
      //react-hook-form
      must_select_udp_or_tcp: 'Debe elegir algún protocolo udp, tcp o ambos',
      must_use_electronic_if_has_dgo_subscription:
        'Debe utilizar facturación electrónica si el cliente posee una suscripción de Directv Go',
      nap_port_not_exist: 'El puerto no existe',
      nap_port_unavailable: 'El puerto seleccionado no esta disponible',
      need_to_save_in_current_account: 'Debe guardar el cambio en la cuenta corriente',
      needs_support_role: 'El usuario debe ser Soporte o Admin para asignar RSA pública',
      no_custom_negative: 'El valor no puede ser menor a -35.',
      no_payment_gateways: 'Sin pasarelas de pago',
      not_a_number: 'no es un número',
      not_an_integer: 'debe ser un entero',
      not_enough_free_nap_ports_to_perform_capacity_decrease:
        'Na hay suficientes puertos libres para realizar la disminución de capacidad',
      not_found: 'no se encontró',
      not_found_ips: 'No hay IPs disponibles',
      not_found_support: 'Algo salió mal. Por favor intenta nuevamente ',
      not_same_mikrotik: 'No es el mismo Mikrotik',
      notification_mail_not_found: 'La notificación mail de ticket cerrado no existe. Contacte con soporte.',
      ntp_server_one_cant_be_equal_to_ntp_server_two: 'No puede ser igual al Segundo Servidor NTP',
      ntp_server_two_cant_be_equal_to_ntp_server_one: 'No puede ser igual al Primer Servidor NTP',
      number_already_in_use: ' El número ya está en uso',
      numbers_must_be_correlative: 'Los números deben ser correlativos',
      only_letters_and_spaces_allowed: 'Solo se permiten letras y espacios',
      only_network: ' No corresponde a la red, la direccion asociada a la red {{network}}',
      only_network_or_final_host: 'Solo Red o Host',
      only_numbers_are_allowed: 'Solo se permiten números',
      only_one_yape_gateway_per_isp: 'Solo se puede tener una pasarela de Yape',
      onts_consumption_not_available: 'Las gráficas de consumo no están disponibles',
      onts_consumption_requires_snmp_port: 'Para ver las gráficas de consumo se necesita conexion por SNMP',
      orderable_already_has_pending_order_with_that_kind: 'Ya tiene una orden pendiente de este tipo.',
      pattern: 'no es válido',
      peru_client_must_have_address: 'Si desea facturar con razón social electrónica, debe especificar una dirección.',
      peru_client_must_have_dni:
        'Si se le emite boletas de venta a una Persona Natural, debe tener DNI en caso de no tener RUC',
      plan_name_cant_use_especial_charts: `no puede usar los siguientes caracteres ( / \\ " ' )`,
      power_limit_cant_be_greater_than_50_and_lower_than_negative_50:
        'La potencia de referencia no puede ser superior a 50 ni inferior a 50 negativo',
      ppp_profile_can_only_be_used_if_the_contract_has_pppoe_enabled:
        'El Perfil PPPoE solo puede ser usado si el contrato tiene el modo de PPPoE Habilitado',
      private_port_already_assigned: 'El puerto privado ya esta siendo usado para un redirección en este contrato',
      profile_cant_be_blank:
        'El contrato no tiene configurado un perfil de facturación. Debe editar el contrato y seleccionar un perfil.',
      profile_does_not_correspond_to_the_server_profiles:
        'El profile seleccionado no corresponde a los profile del servidor del contrato',
      prospect_does_not_have_plan: 'El prospecto no tiene plan.',
      provider_need_use_net_amount:
        'Para facturar con este proveedor, debe usar los montos de facturación como valores netos',
      // react-hook-form
      public_ip_already_used: 'IP pública ya esta en uso.',
      public_port_already_assigned: 'El puerto público ya esta asignado a otro contrato para ese mismo proveedor',
      radius_or_acs_must_be_enabled: 'Radius o ACS deben estar habilitados',
      reaction_not_found: 'La reacción no existe',
      record_invalid: 'La validación falló: {{errors}}',
      record_not_found_in_invoice_service:
        'No se pudo encontrar la razón social en el servicio de facturación. Contacte con soporte',
      required: 'debe existir',
      restrict_dependent_destroy: {
        has_many: 'No se puede eliminar el registro con items dependientes',
        has_one: 'No se puede eliminar el registro con item dependiente'
      },
      rol_category_must_have_scope: 'Debes seleccionar al menos un rol',
      service_error: 'Servicio no disponible. Intente mas tarde',
      service_not_available: 'Servicio no disponible',
      service_unavailable: 'Servicio no disponible',
      should_match: 'no coincide',
      support: 'Algo salió mal, por favor contacte con soporte.',
      taken: 'ya está en uso',
      tickets: 'tickets',
      too_long: 'es demasiado largo ({{count}} caracteres máximo)',
      too_short: 'es demasiado corto ({{count}} caracteres mínimo)',
      total_discounts_exceed_limit: 'El total de los descuentos no puede exceder {{limit}}%',
      uniqueness_cable_modem_ip: 'Ya existe un contrato con esa cable modem IP',
      uniqueness_ip: 'Ya existe un contrato con esa IP',
      unlink_ont_error: 'No se pudo desvincular la ONU del contrato. Intente más tarde.',
      user_not_found: 'El usuario no existe',
      user_notification_not_found: 'La notificación no existe',
      without_availability: 'Sin disponibilidad',
      wrong_length: 'no tiene la longitud correcta ({{count}} caracteres exactos)',
      you_do_not_have_permission: 'No tienes permiso.',
      you_must_select_a_qr: 'Debe seleccionar un QR'
    },
    agent: {
      cannot_be_destroyed: 'No puede eliminar Box si tiene contratos o NAS vinculados',
      acs_access_url_invalid_format: 'Debe incluir protocolo, dominio o IP, y puerto (ej. http://ip:puerto)'
    },
    audit: {
      empty: 'vacío'
    },
    contract: {
      interface_gpon: {
        invalid_format: 'Formato inválido, el correcto es frame/board/port'
      },
      nap_id: {
        nap_should_belong_to_olt: 'La nap debe pertenecer a la olt',
        cant_have_nap_without_olt: 'No se puede asignar una nap sin olt',
        cant_assign_coverage_with_nap: 'No puede asignar NAP si posee nodo wireless'
      },
      nap_name: {
        nap_not_found: 'La NAP no existe',
        nap_should_belong_to_olt: 'La nap debe pertenecer a la olt',
        cant_have_nap_without_olt: 'No se puede asignar una nap sin olt'
      },
      nap_port_name: {
        cant_have_nap_port_without_nap: 'Debe asignar una NAP',
        nap_port_not_found: 'El puerto no existe'
      },
      fiber_code: {
        cant_have_seal_without_olt: 'Debe asignar una OLT',
        seal_not_found: 'El precinto no existe'
      },
      vlans_format: 'Ingrese valores numéricos entre 2 y 4093 para todas las VLAN',
      address: {
        ip: { required: 'primero debes elegir un servidor' },
        netmask: { pattern: 'La máscara de subred no es válida' }
      },
      netmask: {
        pattern: 'La máscara de subred no es válida'
      },
      cable_modem_ip: {
        pattern: 'La ip no es válida'
      },
      cable_modem_gateway: {
        pattern: 'La ip no es válida'
      }
    },
    invoicing: {
      discount: {
        must_be_before_expires_at: 'Debe ser posterior a la fecha de expiración',
        must_be_after_starts_at: 'Debe ser posterior a la fecha de inicio'
      },
      profile: {
        must_be_two_days_less: 'Debe ser al menos 2 días menor que el segundo vencimiento ({{secondDue}}) días',
        must_be_less_to_25days: 'Debe ser menor o igual a 25 si el segundo vencimiento es al final del período',
        must_be_zero_and_hundred: 'Debe ser un porcentaje entre 0 y 100'
      }
    },
    invoice: {
      base: {
        paid_or_void: 'La factura ya ha sido pagada o anulada'
      }
    },
    invoicing_firm: {
      service_url: {
        pattern: 'URL invalida, debe ser algo como: https://api.provider.com/v1/'
      },
      _prefix_peru_next_invoice_number_: {
        pattern: 'Debe empezar con "F" y todas las demas en mayúscula, cantidad de exacta de 4 caracteres'
      },
      peru_next_invoice_credit_note_number: {
        pattern: 'Debe empezar con F y al tener menos 4 caracteres'
      },
      _prefix_peru_next_final_consumer_invoice_number_: {
        pattern: 'Debe empezar con B y al tener menos 4 caracteres'
      },
      _prefix_peru_next_final_consumer_invoice_credit_note_number_: {
        pattern: 'Debe empezar con B y al tener menos 4 caracteres'
      }
    },
    license: {
      hola_suite: {
        invalid_format_api_login: 'Ingrese un formato válido (dominios)',
        url_service_or_token_invalid: 'Debe ingresar una Url y un Token valido'
      }
    },
    nap: {
      first_olt: 'Debes elegir una Olt.',
      fbp: 'Ingrese un formato válido (ejemplo: n°/n°/n°)',
      kingtype_format: 'Ingrese un formato válido de puerto GPON (ejemplo: g01/01).',
      huawei_format: 'Ingrese un formato válido de Frame/Board/Port. Port entre 0 y 15',
      default_format: 'Ingrese un formato válido de Frame/Board/Port. Port entre 1 y 16'
    },
    nap_port: {
      name: {
        taken: 'El nombre del puerto ya esta en uso'
      }
    },
    nas: {
      cannot_be_destroyed: 'No puede eliminar NAS si esta vinculado con un Box'
    },
    notification_sms: {
      body: {
        substitutionsAllowed: 'Alguna sustitución es inválida'
      }
    },
    orders: {
      order: {
        start_at_greather_than_today: 'Fecha de inicio debe ser mayor a la fecha de hoy',
        invalid_images_format: 'El formato de las siguientes imágenes es inválido: {{filenames}}',
        end_at_greater_than_start_at: 'Fecha de finalización debe ser mayor a la fecha de inicio'
      }
    },
    payment: {
      base: {
        invoicing_client_mismatch: 'La factura pertenece a un cliente diferente'
      }
    },
    tv_services: {
      directv_go: {
        cannot_be_modified: 'El valor no puede ser modificado ya que existen subscripciones utilizando este plan',
        client_must_use_colombia_siigo: 'El cliente debe utilizar facturación electrónica con Siigo',
        client_must_use_electronic_invoice: 'El cliente debe utilizar facturación electrónica',
        client_must_have_invoicing_enabled: 'El cliente debe tener facturación habilitada',
        client_must_not_authorize_invoice_after_paid: 'El cliente debe tener autorizar despues de pagar deshabilitado',
        client_must_have_iva_19_tax: 'El cliente debe tener un impuesto de IVA del 19%',
        client_must_have_iva_21_tax: 'El cliente debe tener un impuesto de IVA del 21%',
        client_must_have_peru_igv_18_tax: 'El cliente debe tener un impuesto de IGV del 18%',
        must_be_first_of_upcoming_months: 'Debe ser el primer dia de un mes proximo',
        must_have_one_active_basic_pack: 'Debe tener al menos un plan básico activo',
        must_have_one_active_pack: 'Debe tener al menos un plan activo',
        must_have_only_one_basic_pack: 'Debe tener un solo plan básico',
        must_have_only_one_of_each_pack: 'No puede tener planes duplicados',
        must_wait_until_next_month_to_change_basic_pack: 'Debe esperar al siguiente mes para cambiar de plan básico',
        must_select_a_basic_plan: 'Debe seleccionar un plan básico',
        must_resync: 'Debe resincronizar la subscripción',
        must_reactivate_account_to_update_packs: 'Debe reactivar la suscripción para podear actualizar los planes',
        invalid_mail_format: 'Ingrese una direccion de correo valida',
        invalid_name_format: 'Ingrese un nombre válido',
        invalid_last_name_format: 'Ingrese un apellido válido'
      }
    },
    helpdesk: {
      issue: {
        must_select_a_main_or_secondary_category: 'Debe seleccionar una categoria principal o secundaria',
        expires_at_more_than_or_equals_to_date_today: 'La fecha de vencimiento debe ser mayor o igual a la fecha de hoy'
      }
    },
    hola_notification: {
      automatic_notifications: {
        channels: {
          must_select_channel: 'Debe seleccionar un Canal'
        }
      }
    },
    payment_gateway: {
      must_enter_last_8_digits: 'Debe ingresar los ultimos 8 digitos de la referencia',
      invalid_client_identification_number_format:
        'Formato inválido. Debe comenzar con V, E, J o G seguido de hasta 9 dígitos',
      invalid_client_phone_number_format: 'Formato inválido'
    },
    plan: {
      burst_limit_down_human: {
        must_be_greater_than: 'debe ser mayor que {{string}}'
      },
      burst_limit_up_human: {
        must_be_greater_than: 'debe ser mayor que {{string}}'
      },
      burst_threshold_down_human: {
        greater_than_or_equal_to: 'debe ser mayor que o igual a {{count}}',
        must_be_less_than: 'Debe ser menor o igual que Ráfaga Máx.subida {{string}}, o igual a cero'
      },
      burst_threshold_up_human: {
        greater_than_or_equal_to: 'debe ser mayor que o igual a {{count}}',
        must_be_less_than: 'Debe ser menor o igual que Ráfaga Máx.subida {{string}}, o igual a cero'
      },
      error_week: 'Debe al menos elegir un dia',
      subdomain: {
        maxLength: "es demasiado largo ({{value}} caracteres máximo). It can't start with 0."
      },
      time_from: {
        maxLength: 'no es valido',
        minLength: 'no es valido',
        required: 'no puede estar en blanco',
        validate: 'No puede ser igual a la hora de finalización'
      },
      time_to: {
        maxLength: 'no es valido',
        minLength: 'no es valido',
        required: 'no puede estar en blanco',
        validate: 'No puede ser igual a la hora de inicio'
      }
    },
    portal_configuration: {
      mobile_phone: {
        minLength: 'Numero de Telefono Invalido'
      },
      phone: {
        minLength: 'Numero de Telefono Invalido'
      },
      subdomain: {
        maxLength: 'es demasiado largo ({{value}} caracteres máximo)'
      }
    },
    ppp_profile: {
      dhcpv6_pd_pool: {
        required: 'primero debes elegir un servidor'
      },
      remote_ipv6_prefix_pool: {
        required: 'primero debes elegir un servidor'
      },
      local_address: {
        pattern: 'debe ser un ip'
      },
      mikrotik_dns_server_one: {
        pattern: 'debe ser un ip',
        validate: 'el ip debe ser diferente'
      },
      mikrotik_dns_server_three: {
        pattern: 'debe ser un ip',
        validate: 'el ip debe ser diferente'
      },
      mikrotik_dns_server_two: {
        pattern: 'debe ser un ip',
        validate: 'el ip debe ser diferente'
      }
    },
    sale_desk: {
      lead: {
        invalid_phone_mobile: 'Número de teléfono invalido',
        invalid_phone_number: 'Número de teléfono invalido',
        at_least_one_contact_attr: 'Debe completar al menos un dato de contacto.'
      },
      tags: {
        pattern: 'El color debe ser un código HEX válido (ej. #FFF o #FFFFFF)'
      },
      ticket: {
        invalid_attachments_format: 'El formato de los siguientes archivos es inválido: {{filenames}}'
      }
    },
    seal: {
      end_range_validate: 'El valor fin no puede ser menor o igual al valor inicio.',
      maximun_quantity_batch_seals: 'La cantidad máxima para crear lote es de 1000 precintos.',
      minimun_quantity_batch_seals: 'La cantidad mínima para crear lote es de 50 precintos.',
      only_numbers: 'Por favor, introduzca un número entero',
      start_range_validate: 'El valor inicio no puede ser mayor o igual al valor fin.',
      cannot_be_less_than_0: 'No puede ser menor a 0.'
    },
    sentry: {
      errorFormEntry: 'Algunos campos son inválidos. Por favor corrígelos e intenta nuevamente.',
      errorGeneric: 'Ocurrió un error al enviar tu informe. Por favor intenta nuevamente.',
      labelClose: 'Cerrar',
      labelComments: '¿Qué ha pasado?',
      labelEmail: 'Correo electrónico',
      labelName: 'Nombre',
      labelSubmit: 'Enviar',
      subtitle: 'Nuestro equipo ha sido avisado.',
      subtitle2: 'Si quieres ayudar, dinos que ha pasado a continuación.',
      successMessage: 'Tu feedback ha sido enviado. ¡Gracias!',
      title: 'Parece que hubo un problema.'
    },
    smtp_configuration: {
      port: {
        pattern: 'debe ser mayor que 0'
      }
    },
    service_invoice: {
      from_day_cant_less_or_equal_than_from_day: 'La fecha Hasta no puede ser menor o igual a la fecha Desde'
    },
    networking_form: {
      nap_without_olt:
        'La NAP {{nap_name}} asignada al prospecto no tiene asociada una OLT. Si desea utilizar el formulario de red, asocie la NAP a la OLT correspondiente. De lo contrario, ',
      use_contract_form: 'utilice el formulario de contratos.',
      nap_required:
        'La NAP asignada al prospecto no existe. Si desea utilizar el formulario de red, asocie al prospecto una NAP válida. De lo contrario, ',
      prospect_without_plan:
        'El prospecto no tiene un plan asignado. Si desea utilizar el formulario de red, asocie un plan al prospecto. De lo contrario, '
    }
  }
};
